module.exports = __webpack_public_path__ + "img/73.8a17869e.jpg";